module.exports = {"adminIds":["bbbe0916-f664-487d-8adf-716eef819c67","00d8166a-3e3e-4043-84a2-f357f0848322"]};